/*! JointJS+ v3.6.1 - HTML5 Diagramming Framework

Copyright (c) 2022 client IO

 2022-10-21 


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at http://jointjs.com/license/rappid_v2.txt
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/


import * as joint from '@clientio/rappid';

export class ToolbarService {
    
    create(commandManager, paperScroller) {
        const { tools, groups } = this.getToolbarConfig();
        
        this.toolbar = new joint.ui.Toolbar({
            groups,
            tools,
            references: {
                paperScroller: paperScroller,
                commandManager: commandManager
            }
        });

        this.selectedTool = 'pan';
    }
    
    getToolbarConfig() {
        
        return {
            groups: {
                home: {index: 0, align: 'left'},    
                fileoptions: { index: 1, align: 'right' },
                undoredo: { index: 2, align: 'right' },
                zoom: { index: 3, align: 'right' },
                print: { index: 4, align: 'right' },
                streamtable: { index: 5, align: 'right' },
                //feedback: { index: 6, align: 'right' }
            },
            tools: [
                {
                    type: 'button',
                    name: 'save-as',
                    group: 'fileoptions',
                    text: 'SA', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-save-as',
                            'data-tooltip': 'Save As',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'save-json',
                    group: 'fileoptions',
                    text: 'SV', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-save-json',
                            'data-tooltip': 'Save JSON',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'switch-simulator',
                    group: 'home',
                    text: 'T',
                    attrs: {
                        button: {
                            id: 'btn-switch-simulator',
                            'data-tooltip': 'Switch to Simulator',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'home',
                    group: 'home',
                    text: 'H', // This adds the label to the button
                    attrs: {
                        button: {
                            id: 'btn-home',
                            'data-tooltip': 'Home',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'zoom-in',
                    name: 'zoom-in',
                    group: 'zoom',
                    attrs: {
                        button: {
                            'data-tooltip': 'Zoom In',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'zoom-out',
                    name: 'zoom-out',
                    group: 'zoom',
                    attrs: {
                        button: {
                            'data-tooltip': 'Zoom Out',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'undo',
                    name: 'undo',
                    group: 'undoredo',
                    attrs: {
                        button: {
                            'data-tooltip': 'Undo',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'redo',
                    name: 'redo',
                    group: 'undoredo',
                    attrs: {
                        button: {
                            'data-tooltip': 'Redo',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'print',
                    group: 'print',
                    attrs: {
                        button: {
                            id: 'btn-print',
                            'data-tooltip': 'Print to PDF',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'download',
                    group: 'fileoptions',
                    attrs: {
                        button: {
                            id: 'btn-download',
                            'data-tooltip': 'Download JSON file',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                {
                    type: 'button',
                    name: 'upload',
                    group: 'fileoptions',
                    attrs: {
                        button: {
                            id: 'btn-upload',
                            'data-tooltip': 'Load JSON file',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbarContainer'
                        }
                    }
                },
                /*{
                    type: 'button',
                    name: 'feedback',
                    group: 'feedback',
                    text: 'Feedback',
                    attrs: {
                        button: {
                            'data-tooltip': 'Tell us what you think!',
                            'data-tooltip-position': 'top',
                            'data-tooltip-position-selector': '.toolbar-container'
                        }
                    }
                },*/
            ]
        };
    }
}
